/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Albuminuria F13 List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminuriaF13ListView';

export const mapStateToPropsAlbuminuriaF13List = mapStateToProps;
export const mapDispatchToPropsAlbuminuriaF13List = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbuminuriaF13List,
  mapDispatchToPropsAlbuminuriaF13List
)(View);
